import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import debounce from 'lodash.debounce'
import InputText from '../input-text'

// component which will handle input text with as a search field
const InputSearch = ({ searchText: searchTextValue, onChangeSearchText, onClearSearchText, debounceTime = 0, ...props}) => {
    const [searchText, setSearchText] = useState(searchTextValue);

    const onChangeRef = useRef(onChangeSearchText);
    useEffect(() => {
        onChangeRef.current = onChangeSearchText;
    });

    const debouncedOnChange = useMemo(
        () => (debounceTime > 0 ? debounce((value) => onChangeRef.current && onChangeRef.current(value), debounceTime) : null),
        [debounceTime]
    );

    useEffect(() => () => debouncedOnChange?.cancel(), [debouncedOnChange]);

    const handleSearchChange = useCallback((value) => {
        setSearchText(value);
        if (debouncedOnChange) debouncedOnChange(value);
        else onChangeSearchText && onChangeSearchText(value)
    }, [onChangeSearchText, debouncedOnChange]);

    const handleSearchIconClick = useCallback(() => {
        if (searchText) {
            setSearchText("")

            // call callbacks
            debouncedOnChange?.cancel();
            onChangeSearchText && onChangeSearchText("")
            onClearSearchText && onClearSearchText()
        }
    }, [searchText, onChangeSearchText, onClearSearchText, debouncedOnChange]);

    useEffect(() => {
      if(searchTextValue){
        setSearchText(searchTextValue)
      }
    }, [searchTextValue])


  return (
    <InputText
        placeholder="Search"
        hideLabel
        value={searchText}
        onChange={handleSearchChange}
        iconSrc={`/images/icon/${searchText ? "close.svg" : "search-black.svg"}`}
        onIconClick={handleSearchIconClick}
        {...props}
    />
  )
}

export default InputSearch
